const endpoints = {
  gam_creatives: {
    response: () => import('./stubs/gam/creatives.json' /* webpackChunkName: "API.gam_creatives", webpackPrefetch: 0 */),
    regex: /gam\/creatives/,
  },
  gam_licas: {
    response: (uri, config) => {
      if (config && (config.siteUrl || !config.licaIds)) {
        return import('./stubs/gam/tearsheet.json' /* webpackChunkName: "API.gam_tearsheet", webpackPrefetch: 0 */)
      }

      return import('./stubs/gam/licas.json' /* webpackChunkName: "API.gam_licas", webpackPrefetch: 0 */)
    },
    regex: /gam\/licas/,
  },

  master_data_publishers: {
    response: () => import('./stubs/publishers.json' /* webpackChunkName: "API.master_data_publishers", webpackPrefetch: 0 */),
    regex: /master_data\/publishers/,
  },
  master_data_teams: {
    response: () => import('./stubs/teams.json' /* webpackChunkName: "API.master_data_teams", webpackPrefetch: 0 */),
    regex: /master_data\/teams/,
  },

  reports_data_refresh: {
    response: () => import('./stubs/reports/data_refresh.json' /* webpackChunkName: "API.reports_data_refresh", webpackPrefetch: 0 */),
    regex: /reports\/data_refresh/,
  },
  reports_delivery_creatives: {
    response: () => import('./stubs/reports/delivery_creatives.json' /* webpackChunkName: "API.reports_delivery_creatives", webpackPrefetch: 0 */),
    regex: /reports\/delivery_creatives/,
  },
  reports_delivery_line_items: {
    response: () => import('./stubs/reports/delivery_line_items.json' /* webpackChunkName: "API.reports_delivery_line_items", webpackPrefetch: 0 */),
    regex: /reports\/delivery_line_items/,
  },
  reports_discrepancy_creatives: {
    response: () => import('./stubs/reports/discrepancy_creatives.json' /* webpackChunkName: "API.reports_discrepancy_creatives", webpackPrefetch: 0 */),
    regex: /reports\/discrepancy_creatives/,
  },
  reports_discrepancy_line_items: {
    response: () => import('./stubs/reports/discrepancy_line_items.json' /* webpackChunkName: "API.reports_discrepancy_line_items", webpackPrefetch: 0 */),
    regex: /reports\/discrepancy_line_items/,
  },
  reports_pacing_line_items: {
    response: () => import('./stubs/reports/pacing_line_items.json' /* webpackChunkName: "API.reports_pacing_line_items", webpackPrefetch: 0 */),
    regex: /reports\/pacing_line_items\b/,
  },
  reports_pacing_line_items_summary: {
    response: () => import('./stubs/reports/pacing_line_items_summary.json' /* webpackChunkName: "API.reports_pacing_line_items_summary", webpackPrefetch: 0 */),
    regex: /reports\/pacing_line_items_summary/,
  },

  timesheet_clients: {
    response: () => import('./stubs/clients.json' /* webpackChunkName: "API.timesheet_clients", webpackPrefetch: 0 */),
    regex: /timesheet\/clients/,
  },
  // @TODO: Implement stub of the Person API endpoint
  // timesheet_persons: {
  //   response: () => import('./stubs/persons.json'),
  //   regex: /timesheet\/persons/,
  // },
  timesheet_projects: {
    response: () => import('./stubs/projects.json' /* webpackChunkName: "API.timesheet_projects", webpackPrefetch: 0 */),
    regex: /timesheet\/projects/,
  },

  trafficking_line_items: {
    response: () => import('./stubs/line_items.json' /* webpackChunkName: "API.trafficking_line_items", webpackPrefetch: 0 */),
    regex: /trafficking_objects\/line_items/,
  },
  trafficking_orders: {
    response: () => import('./stubs/orders.json' /* webpackChunkName: "API.trafficking_orders", webpackPrefetch: 0 */),
    regex: /trafficking_objects\/orders/,
  },
}

const stub = {
  ...endpoints,

  testEndpoint(regex, uri) {
    const [baseRoute] = uri.split('?')
    return regex.test(baseRoute)
  },

  reduceMatchingEndpoint(uri, config) {
    return (match, endpointKey) => {
      if (match) return match

      const endpoint = endpoints[endpointKey]
      const { regex, response } = endpoint
      const foundEndpoint = this.testEndpoint(regex, uri)

      return foundEndpoint ? response(uri, config) : false
    }
  },

  /**
   * Gets relevant stub data when needed, else returns null.
   * @param {string} uri The requested URI, typically an API URI.
   * @param {Object} [config] An HTTP config object passed to Axios.
   * @return {null|string} JSON string from the stub file, or null.
   */
  request(uri, config) {
    const endpointsArray = Object.keys(endpoints)
    const matchingEndpoint = this.reduceMatchingEndpoint(uri, config)

    return endpointsArray.reduce(matchingEndpoint, null)
  },
}

export default stub
